import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["width", "height", "viewBox", "fill"];
const _hoisted_2 = ["fill", "fill-opacity"];
export default /*#__PURE__*/ _defineComponent({
    __name: 'CloseIcon',
    props: {
        width: { default: 20 },
        height: { default: 20 },
        viewBox: { default: '0 0 20 20' },
        background: { default: 'none' },
        color: { default: 'black' },
        opacity: { default: 0.32 }
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: _ctx.width,
                height: _ctx.height,
                viewBox: _ctx.viewBox,
                fill: _ctx.background
            }, [
                _createElementVNode("path", {
                    d: "M8.06468 10.1396L8.24146 9.9628L8.06468 9.78602L0.655676 2.37702C0.437688 2.14149 0.319084 1.83079 0.324748 1.50981C0.330436 1.18742 0.461035 0.879829 0.689032 0.651832C0.91703 0.423835 1.22462 0.293236 1.54701 0.287547C1.86799 0.281884 2.17869 0.400488 2.41422 0.618476L9.82322 8.02748L10 8.20426L10.1768 8.02748L17.5858 0.618474C17.8213 0.400487 18.132 0.281884 18.453 0.287547C18.7754 0.293236 19.083 0.423835 19.311 0.651832C19.539 0.87983 19.6696 1.18742 19.6753 1.50981C19.6809 1.8308 19.5623 2.1415 19.3443 2.37703L11.9353 9.78602L11.7585 9.9628L11.9353 10.1396L19.3476 17.5518L19.3475 17.552L19.3539 17.558C19.4762 17.6719 19.5743 17.8093 19.6423 17.9619C19.7103 18.1146 19.7469 18.2794 19.7498 18.4464C19.7528 18.6135 19.722 18.7795 19.6594 18.9344C19.5968 19.0894 19.5037 19.2302 19.3855 19.3483C19.2674 19.4665 19.1266 19.5596 18.9716 19.6222C18.8167 19.6848 18.6507 19.7156 18.4836 19.7126C18.3166 19.7097 18.1518 19.6731 17.9991 19.6051C17.8465 19.5371 17.7091 19.439 17.5952 19.3167L17.5953 19.3166L17.589 19.3104L10.1768 11.8981L10 11.7213L9.82322 11.8981L2.41096 19.3104L2.41085 19.3103L2.40483 19.3167C2.29091 19.439 2.15352 19.5371 2.00088 19.6051C1.84823 19.6731 1.68345 19.7097 1.51636 19.7126C1.34927 19.7156 1.1833 19.6848 1.02835 19.6222C0.873403 19.5596 0.732645 19.4665 0.614479 19.3483C0.496311 19.2302 0.403155 19.0894 0.340569 18.9344C0.277982 18.7795 0.247246 18.6135 0.250194 18.4464C0.253142 18.2794 0.289714 18.1146 0.357727 17.9619C0.425742 17.8093 0.523805 17.6719 0.646067 17.558L0.646173 17.5581L0.652413 17.5518L8.06468 10.1396Z",
                    fill: _ctx.color,
                    "fill-opacity": _ctx.opacity,
                    stroke: "white",
                    "stroke-width": "0.5"
                }, null, 8, _hoisted_2)
            ], 8, _hoisted_1));
        };
    }
});
